import { Box, styled } from "components/common";

export const ProductHeaderWrapper = styled(Box)(({ theme }) => ({
  margin: theme.spacing(3),
  "& .title": {
    margin: "10px 0px",
    fontSize: "28px",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  "& .right": {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "start",
      gap: theme.spacing(1),
    },
  },
  "& .nav": {
    marginBottom: "10px",
    color: "#666",
    fontSize: "16px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    textTransform: "capitalize",
    "& .home-link": {
      textDecoration: "none",
      color: "inherit",
    },
  },
  "& .main": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .right": {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
    },
  },
}));
